import React from 'react';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../../../../store/global-selectors';
import {
  INVENTORY_WAREHOUSE,
  ORDER_STATUS,
  LABEL_PROVIDER,
  SHIP_FROM_LOCATION,
  STORE,
  USER,
  DROP_DOWN,
} from '../../../report-filters/constants';
import {
  PARAMETER_NAME_USER,
  PARAMETER_NAME_INVENTORY_WAREHOUSE_ID,
  PARAMETER_NAME_LABEL_PROVIDER_ID,
  PARAMETER_NAME_WAREHOUSE_ID,
} from '../../report-parameter-names';
import * as dropdownOptions from './constants';
import { optionsMessages } from './messages';

const orderStatusOptions = {
  [ORDER_STATUS]: [
    dropdownOptions.AWAITING_PAYMENT,
    dropdownOptions.AWAITING_SHIPMENT,
    dropdownOptions.SHIPPED,
    dropdownOptions.CANCELLED,
    dropdownOptions.ON_HOLD,
    dropdownOptions.PENDING_FULFILLMENT,
    dropdownOptions.REJECTED_FULFILLMENT,
  ],
};

const buildOrderStatusOptions = ({ apiKey, filterType }) =>
  orderStatusOptions[filterType].map((option, index) => ({
    name: <FormattedMessage {...optionsMessages[option]} />,
    [apiKey]: index + 1,
  }));

export const buildDropdownOptions = ({ filtersProps, state }) => {
  const optionCollectionsHash = {
    [INVENTORY_WAREHOUSE]: () =>
      Global.selectSellerInventoryWarehouses(state).map((wrh) => ({
        ...wrh,
        [PARAMETER_NAME_INVENTORY_WAREHOUSE_ID]: wrh.inventoryWarehouseId,
      })),
    [ORDER_STATUS]: ({ apiKey, filterType }) => buildOrderStatusOptions({ apiKey, filterType }),
    [LABEL_PROVIDER]: () =>
      Global.selectReferenceDatagetProviders(state).map((prov) => ({
        ...prov,
        [PARAMETER_NAME_LABEL_PROVIDER_ID]: prov.labelProviderId,
      })),
    [SHIP_FROM_LOCATION]: () =>
      Global.selectSellerShipFroms(state).map((shipFrom) => ({
        ...shipFrom,
        [PARAMETER_NAME_WAREHOUSE_ID]: shipFrom.shipFromId,
      })),
    [STORE]: () => Global.selectSellerActiveStores(state),
    [USER]: () =>
      Global.selectSellerUsers(state).map((user) => ({
        ...user,
        [PARAMETER_NAME_USER]: user.userId,
      })),
  };

  return filtersProps.reduce((result, filterProps) => {
    if (filterProps.type === DROP_DOWN) {
      const newFilterProps = { ...filterProps };
      const { apiKey, filterType, options = [] } = newFilterProps;
      const optionsFromHash = optionCollectionsHash[filterType];
      const hasOptionsFromHash = !!optionsFromHash;
      const updatedOptions = hasOptionsFromHash ? [...options, ...optionsFromHash({ apiKey, filterType })] : options;
      newFilterProps.options = updatedOptions;
      return [...result, newFilterProps];
    }
    return [...result, filterProps];
  }, []);
};
